import { o as onReady } from './app-chunk-common-BPZAsnhF.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const url = "/pages/update-nuun-box-subscription";

const msg = `Your subscription will not ship until you update your payment method. Please <a href="${url}">update your payment method here</a>.`;

const paymentMsg = `To update your payment method please <a href="${url}">visit this page</a>.`;

const addressMsg = `To update your address please first <a href="${url}">update your payment details here</a>.`;

const isLegacyPaymentMethod = async () => {
  const res = await window.ReCharge.Api.getPaymentMethods();
  const methods = res.data.payment_methods;

  if (methods.length === 0) {
    return true;
  }

  for (let i = 0; i < methods.length; i++) {
    const m = methods[i];
    if (m.processor_name === "shopify_payments") {
      return false;
    }
  }
  return true;
};

const injectSubscriptionPageContent = async () => {
  const content = document.querySelector(".rct_content");

  if (!content) {
    return;
  }

  const isLegacy = await isLegacyPaymentMethod();

  if (!isLegacy) {
    return;
  }

  const el = document.createElement("div");
  el.className = "nuun-recharge-portal__alert";
  el.innerHTML = msg;

  const firstChild = content.childNodes[0];
  content.insertBefore(el, firstChild);
};

const injectMsg = async (selector, extraShowElements, msg) => {
  const content = document.querySelector(".rct_content");

  const showContent = () => {
    document.querySelector(selector).style.display = "block";

    if (extraShowElements) {
      const otherElements = document.querySelectorAll(extraShowElements);
      for (let i = 0; i < otherElements.length; i++) {
        const el = otherElements[i];
        el.style.display = "auto";
      }
    }
  };

  if (!content) {
    showContent();
    return;
  }

  const isLegacy = await isLegacyPaymentMethod();

  if (isLegacy === false) {
    showContent();
    return;
  }

  const el = document.createElement("div");
  el.className = "nuun-recharge-portal__alert";
  el.innerHTML = msg;

  const firstChild = content.childNodes[0];
  content.insertBefore(el, firstChild);
};

var initRechargeCustomerPortal = () => {
  if (window.location.pathname.endsWith("/subscriptions")) {
    injectSubscriptionPageContent();
  }

  if (window.location.pathname.endsWith("/payment_methods")) {
    injectMsg("#PaymentMethodsPage", null, paymentMsg);
  }

  if (window.location.pathname.endsWith("/shipping")) {
    injectMsg("#ShippingPage", ".add-shiping-info", addressMsg);
  }
};

onReady(() => {
  initRechargeCustomerPortal();
});
